import { OccCustomerConsignment } from '@checkout-v2/const';
import { StateUtils } from '@spartacus/core';
import { CUSTOMER_CONSIGNMENT } from '../checkout-state';

export const UPDATE_CUSTOMER_CONSIGNMENT = '[Checkout] Update Customer Consignment';
export const UPDATE_CUSTOMER_CONSIGNMENT_SUCCESS = '[Checkout] Update Customer Consignment Success';
export const UPDATE_CUSTOMER_CONSIGNMENT_FAIL = '[Checkout] Update Customer Consignment Fail';

export class UpdateCustomerConsignment extends StateUtils.LoaderLoadAction {
  readonly type = UPDATE_CUSTOMER_CONSIGNMENT;

  constructor(public payload: OccCustomerConsignment) {
    super(CUSTOMER_CONSIGNMENT);
  }
}

export class UpdateCustomerConsignmentSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = UPDATE_CUSTOMER_CONSIGNMENT_SUCCESS;

  constructor(public payload: OccCustomerConsignment) {
    super(CUSTOMER_CONSIGNMENT);
  }
}

export class UpdateCustomerConsignmentFail extends StateUtils.LoaderFailAction {
  readonly type = UPDATE_CUSTOMER_CONSIGNMENT_FAIL;

  constructor(public payload: unknown) {
    super(CUSTOMER_CONSIGNMENT);
  }
}

export type CustomerConsignmentActions =
  | UpdateCustomerConsignment
  | UpdateCustomerConsignmentSuccess
  | UpdateCustomerConsignmentFail;
